<section class="px-14 py-10 flex flex-col gap-4" [formGroup]="form">
  <article class="w-full text-[#353C40] flex flex-col gap-1">
    <header
      class="flex flex-col md:flex-row md:justify-between justify-center items-start md:items-center mb-4">
      <h3 class="text-center text-[1.8rem] font-bold tracking-tight">
        Add Note
      </h3>
      <h4 class="text-center text-[.9rem] font-semibold">
        {{ today | date: 'MM/dd/yyyy h:mm a' }}
      </h4>
    </header>
    <app-ccs-textarea
      class="w-full"
      label="Freeform Entry"
      placeholder="Enter freeform text"
      formControlName="content"
      [autosizeMinRow]="7.5"
      [autosizeMaxRow]="7.5" />

    <span class="flex justify-end items-center font-normal">
      This note is public?
      <mat-checkbox formControlName="is_public" />
    </span>
  </article>
  <article class="flex flex-col md:flex-row gap-7 w-full">
    <button class="md w-full md:flex-1" mat-dialog-close mat-stroked-button>
      Close
    </button>
    <button
      class="md w-full md:flex-1"
      mat-flat-button
      [mat-dialog-close]="formValue"
      [disabled]="!form.valid">
      Save
    </button>
  </article>
</section>
